﻿$.fn.dxCtrlImgSimpleStrConUti = function custom_dxCtrlImgSimpleStrConUti(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlimgsimplestrconuti dx-ctrl");
        this.createInstance(new cdxCtrlImgSimpleStrConUti(this, option));
    }
    return this;
}

var lstUrlImageObjet = []
window.mRemoveSaveMemoryImage = function (idTable, id) {
    if (lstUrlImageObjet.filter(function (o) { return o.id == id && o.idTable == idTable }).length > 0) {
        lstUrlImageObjet.splice(lstUrlImageObjet.indexOf(lstUrlImageObjet.filter(function (o) { return o.id == id && o.idTable == idTable })[0]), 1)
    }
}
window.mTriggerUpdateMemoryImage = function (bddCtrl, idTable, id) {
    $("body").find(".dx-ctrlimgsimplestrconuti[id_table='" + idTable + "'][id='" + id + "']").each(function (idx, ele) {
        var inst = $(ele).getInstance()
        if (typeof inst != "undefined" && inst != null) inst.mReload()
    })
    debugger;
    bddCtrl.triggerFunctionOnModifiedItemData(bddCtrl.table.mGetItem(idTable).nom, "modif", bddCtrl.getObjet(bddCtrl.table.mGetItem(idTable).nom, id).data)

    if (bddCtrl.table.mGetItem(idTable).nom == 'structures') {
        bddCtrl.getObjet("structures_contact").objetMetier.mGetLstDataStrCon(id, null, function (lst) {
            lst.forEach(function (dataStrCon) {
                $("body").find(".dx-ctrlimgsimplestrconuti[id_table='" + bddCtrl.getObjet("structures_contact").mGetTable().id_table + "'][id='" + dataStrCon.id_structures_contact + "']").each(function (idx, ele) {
                    var inst = $(ele).getInstance()
                    if (typeof inst != "undefined" && inst != null) inst.mReload()
                })
            })
        })
        //bddCtrl.mAjaxCall({
        //    command: "getlstidstructurescontactfromstructures",
        //    id_structures: id
        //}, function (data) {
        //    if (!data.lstidstructurescontact) data.lstidstructurescontact = []
        //    data.lstidstructurescontact.forEach(function (idStrCon) {
        //        $("body").find(".dx-ctrlimgsimplestrconuti[id_table='" + bddCtrl.getObjet("structures_contact").mGetTable().id_table + "'][id='" + idStrCon.id_structures_contact + "']").each(function (idx, ele) {
        //            var inst = $(ele).getInstance()
        //            if (typeof inst != "undefined" && inst != null) inst.mReload()
        //        })
        //    })
        //})
        ////bddCtrl.mGetArray("structures_contact").filter(function (o) { return o.id_structures == id }).forEach(function (data) {
        ////    $("body").find(".dx-ctrlimgsimplestrconuti[id_table='" + bddCtrl.getObjet("structures_contact", data.id_structures_contact).mGetTable().id_table + "'][id='" + data.id_structures_contact + "']").each(function (idx, ele) {
        ////        var inst = $(ele).getInstance()
        ////        if (typeof inst != "undefined" && inst != null) inst.mReload()
        ////    })
        ////})
    }
    if (bddCtrl.table.mGetItem(idTable).nom == 'contact') {
        bddCtrl.getObjet("structures_contact").objetMetier.mGetLstDataStrCon(null, id, function (lst) {
            lst.forEach(function (dataStrCon) {
                $("body").find(".dx-ctrlimgsimplestrconuti[id_table='" + bddCtrl.getObjet("structures_contact").mGetTable().id_table + "'][id='" + dataStrCon.id_structures_contact + "']").each(function (idx, ele) {
                    var inst = $(ele).getInstance()
                    if (typeof inst != "undefined" && inst != null) inst.mReload()
                })
            })
        })

        //bddCtrl.mAjaxCall({
        //    command: "getlstidstructurescontactfromcontact",
        //    id_contact: id
        //}, function (data) {
        //    if (!data.lstidstructurescontact) data.lstidstructurescontact = []
        //    data.lstidstructurescontact.forEach(function (idStrCon) {
        //        $("body").find(".dx-ctrlimgsimplestrconuti[id_table='" + bddCtrl.getObjet("structures_contact").mGetTable().id_table + "'][id='" + idStrCon.id_structures_contact + "']").each(function (idx, ele) {
        //            var inst = $(ele).getInstance()
        //            if (typeof inst != "undefined" && inst != null) inst.mReload()
        //        })
        //    })
        //})
        ////bddCtrl.mGetArray("structures_contact").filter(function (o) { return o.id_contact == id }).forEach(function (data) {
        ////    $("body").find(".dx-ctrlimgsimplestrconuti[id_table='" + bddCtrl.getObjet("structures_contact", data.id_structures_contact).mGetTable().id_table + "'][id='" + data.id_structures_contact + "']").each(function (idx, ele) {
        ////        var inst = $(ele).getInstance()
        ////        if (typeof inst != "undefined" && inst != null) inst.mReload()
        ////    })
        ////})
    }
}

window.cdxCtrlImgSimpleStrConUti = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.hideIcone == 'undefined') option.hideIcone = false

    const now = Date.now();
    // Filtrer la liste : garder que les objets dont dcr est dans les 5 dernières secondes
    lstUrlImageObjet = lstUrlImageObjet.filter(item => {
        const dateDcr = new Date(item.dcr).getTime();
        // garde si la date est >= maintenant - 5 secondes (5000 ms)
        return dateDcr >= now - 300000;
    });

    var url1 = null
    var url2 = null
    function mConstruit() {
        container.empty();
        container.css({
            position: "relative",
            "border-radius": "20%",
            "overflow": "hidden",
            "background-color": theme.backgroundcolorBase
        })

        container.attr("id_table", option.idTable)
        container.attr("id", option.id)

        if (option.bddCtrl.nom_base.endsWith("_aagest") &&
            (option.idTable == option.bddCtrl.table.mGetItemFromNom("structures").id_table ||
                option.idTable == option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table)) {
            if (option.bddCtrl.nom_base.endsWith("_aagest")) {
                var idCompteClient = null
                if (typeof option.dataTemplate == 'undefined') {
                    if (option.idTable == option.bddCtrl.table.mGetItemFromNom("structures").id_table) {
                        option.bddCtrl.mAjaxCall({
                            command: "getidcompteclient",
                            id_structures: option.id
                        }, function (data) {
                            idCompteClient = data.id_compte_client
                            if (idCompteClient) {
                                $("<i class='fas fa-burst' style='color:red;position:absolute;top:5px;right:5px;z-index:1;font-size:140%;'></i>").appendTo(container)
                            }
                        })
                        //var obj = option.bddCtrl.getObjet("structures", option.id)
                        //if (obj.data) idCompteClient = obj.data.id_compte_client
                    } else if (option.idTable == option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table) {
                        option.bddCtrl.mAjaxCall({
                            command: "getidcompteclient",
                            id_structures_contact: option.id
                        }, function (data) {
                            idCompteClient = data.id_compte_client
                            if (idCompteClient) {
                                $("<i class='fas fa-burst' style='color:red;position:absolute;top:5px;right:5px;z-index:1;font-size:140%;'></i>").appendTo(container)
                            }
                        })
                        //var obj = option.bddCtrl.getObjet("structures_contact", option.id)
                        //if (obj.data) idCompteClient = obj.data.id_compte_client
                    }
                } else {
                    idCompteClient = option.dataTemplate.id_compte_client
                    if (idCompteClient) {
                        $("<i class='fas fa-burst' style='color:red;position:absolute;top:5px;right:5px;z-index:1;font-size:140%;'></i>").appendTo(container)
                    }
                }
            }
        }

        if (typeof option.idTable != "undefined" && option.idTable != null) {
            url1 = null
            url2 = null
            if (option.bddCtrl.table.mGetItem(option.idTable).nom == 'utilisateur') {
                var icon = "fas fa-user"
                if (option.id == 99999) { icon = "fas fa-robot" }
                else if (option.id <= 99998) { icon = "fas fa-universal-access" }
                url1 = option.bddCtrl.repertoireImageTable.substring(1) + "/utilisateur/" + option.id + ".png"
                mRempliImage1(url1, icon, option.idTable, option.id)
            } else if (option.bddCtrl.table.mGetItem(option.idTable).nom == 'structures') {
                var icon = "fas fa-home"
                url1 = option.bddCtrl.repertoireImageTable.substring(1) + "/structures/" + option.id + ".png"
                mRempliImage1(url1, icon, option.idTable, option.id)
            } else if (option.bddCtrl.table.mGetItem(option.idTable).nom == 'contact') {
                var icon = "fas fa-portrait"
                url1 = option.bddCtrl.repertoireImageTable.substring(1) + "/contact/" + option.id + ".png"
                mRempliImage1(url1, icon, option.idTable, option.id)
            } else if (option.bddCtrl.table.mGetItem(option.idTable).nom == 'compte_client') {
                var icon = "fas fa-address-card"
                url1 = option.bddCtrl.repertoireImageTable.substring(1) + "/compte_client/" + option.id + ".png"
                mRempliImage1(url1, icon, option.idTable, option.id)
            } else if (option.bddCtrl.table.mGetItem(option.idTable).nom == 'structures_contact') {
                var idStr = null
                var idCon = null
                if (option.dataTemplate) {
                    idStr = option.dataTemplate.id_str
                    idCon = option.dataTemplate.id_con
                    mRempli()
                } else {
                    option.bddCtrl.mAjaxCall({
                        command: "getdatastructurescontact",
                        id_structures_contact: option.id
                    }, function (data) {
                        if (data.lstdatastrcon.length > 0) {
                            idStr = data.lstdatastrcon[0].id_structures
                            idCon = data.lstdatastrcon[0].id_contact
                        }
                        mRempli()
                    })
                    //var obj = option.bddCtrl.getObjet("structures_contact", option.id)
                    //if (typeof obj.data != "undefined") {
                    //    idStr = obj.data.id_structures
                    //    idCon = obj.data.id_contact
                    //}
                    //mRempli()
                }
                function mRempli() {
                    //var obj = option.bddCtrl.getObjet("structures_contact", option.id)
                    if (idStr == null) {
                        //supprimer (corbeille)
                        mRempliIcone1("fas fa-home")
                        mRempliIcone2("fas fa-portrait")
                    } else {
                        var icon = "fas fa-home"
                        url1 = option.bddCtrl.repertoireImageTable.substring(1) + "/structures/" + idStr + ".png"
                        mRempliImage1(url1, icon, option.bddCtrl.table.mGetItemFromNom("structures").id_table, idStr)

                        var icon = "fas fa-portrait"
                        url2 = option.bddCtrl.repertoireImageTable.substring(1) + "/contact/" + idCon + ".png"
                        mRempliImage2(url2, icon, option.bddCtrl.table.mGetItemFromNom("contact").id_table, idCon)
                    }
                }

            } else if (option.bddCtrl.table.mGetItem(option.idTable).nom == 'compte_client_utilisateur') {
                var obj = option.bddCtrl.getObjet("compte_client_utilisateur", option.id)
                var idcptCli = obj.data.id_compte_client

                var icon = "fas fa-address-card"
                url1 = option.bddCtrl.repertoireImageTable.substring(1) + "/compte_client/" + idcptCli + ".png"
                mRempliImage1(url1, icon, option.bddCtrl.table.mGetItemFromNom("compte_client").id_table, idcptCli)

                var icon = "fas fa-child"
                url2 = option.bddCtrl.repertoireImageTable.substring(1) + "/compte_client_utilisateur/" + option.id + ".png"
                mRempliImage2(url2, icon, option.bddCtrl.table.mGetItemFromNom("compte_client_utilisateur").id_table, option.id)
            }

        }
        else if (typeof option.icon1 != 'undefined') {
            //on veut afficher un icone
            mRempliIcone1(option.icon1)
            if (typeof option.icon2 != 'undefined' && option.icon2.length > 0) mRempliIcone2(option.icon2)
        } else if (option.url_image) {
            url1 = option.url_image
            mRempliImage1(url1, icon)
        }

        if (typeof option.count != "undefined") {
            $("<div style='position:absolute;bottom:0;left:0;font-size:100%;text-align:center;width:100%;font-weight:bold;color:" + theme.backgroundcolorAccent + ";-webkit-text-stroke: 0.1px " + theme.color + ";font-family:barlow condensed;' class='count'>" + option.count + "</div>").appendTo(container)
        }

        if (option.text) container.attr("title", option.text)
        if (option.allowClickImage && option.bddCtrl.utiCourant.id_utilisateur > 99999) {
            container.addClass("state-hover")
            container.off("click")
            container.on("click", function (e) {
                e.stopPropagation()
                var srcImgRef = url1
                if (url2 != null) {
                    srcImgRef = url2
                }
                if (srcImgRef == null || srcImgRef == "") {
                    var searchStringWeb = ((typeof option.text != 'undefined') ? option.text : "")
                    var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                        bddCtrl: option.bddCtrl,
                        icone: false,
                        imgInternet: true,
                        multiple: false,
                        selectedItem: "machine",
                        accept: ".png,.jpg,.jpeg,.gif,.bmp",
                        optionImgInternet: {
                            bddCtrl: option.bddCtrl,
                            searchStringImageWeb: searchStringWeb
                        },
                        onValide: function (lstUrlFile) {
                            if (lstUrlFile.length > 0) {
                                jaugeDemarrage.mShow();
                                (new cImage(option.bddCtrl)).mImgUrltoData64(lstUrlFile[0], function (dataUrl) {
                                    jaugeDemarrage.mHide()
                                    pop.hide()
                                    mCrop(dataUrl);
                                }, function () {
                                    jaugeDemarrage.mHide()
                                    mNotify("Impossible d'utiliser cette image", "error", 6000)
                                })
                            }
                        }
                    }).dxCtrlFileUploaderPopup("instance")
                } else {
                    mCrop(srcImgRef)
                }
            })
        }

        if (option.onChangeUtilisateur) {
            if (parametre.baseAppli.para.is_multi_utilisateur == "1" && option.bddCtrl.mGetArray("utilisateur").filter(function (o) { return o.date_abandon == null && o.is_robot == 0 && o.id_utilisateur != option.id }).length > 0) {
                container.addClass("state-hover")
                container.on("click", function (e) {
                    var tt2 = $("<div/>").appendTo("body").dxCtrlTooltip({
                        target: $(this),
                        width: 220,
                        contentTemplate: function (contentElement) {
                            contentElement.css("white-space", "normal")
                            contentElement.css("padding", "10px")
                            option.bddCtrl.mGetArray("utilisateur").filter(function (o) { return o.date_abandon == null && o.is_robot == 0 && o.id_utilisateur != option.id }).forEach(function (dataUti) {
                                var objUti = option.bddCtrl.getObjet(dataUti)
                                var $DivVide = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                                    "style='padding:5px 0;width:100%;height:auto;text-align:left;margin:5px 0;line-height:1;'>" +
                                    "<div class='contenu' style='padding:5px;white-space:nowrap;display:flex;align-items:center;overflow:hidden;text-overflow:ellipsis;'>" +
                                    "<span class='imguti'></span><span style='font-size:100%;font-style:italic;overflow:hidden;text-overflow:ellipsis;' class='detail'>&nbsp;<b>" + objUti.mGetLib1() + "</b>" +
                                    "</span>" +
                                    "</div>" +
                                    "</div>").appendTo(contentElement)
                                $("<div style='width:30px;height:30px;border-radius:50%;opacity:1;'/>").appendTo($DivVide.find(".imguti")).dxCtrlImgSimpleStrConUti({
                                    bddCtrl: option.bddCtrl,
                                    idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
                                    id: dataUti.id_utilisateur
                                })
                                $DivVide.on("click", function (e) {
                                    tt2.hide()
                                    option.onChangeUtilisateur(dataUti.id_utilisateur)
                                    //var table = option.bddCtrl.table.mGetItem(dataTemplate.id_table)
                                    //var obj = option.bddCtrl.getObjet(table.nom, dataTemplate.id)
                                    //obj.data.id_utilisateur = dataUti.id_utilisateur
                                    //obj.mSaveChamp("id_utilisateur")
                                    //dataTemplate.id_utilisateur = dataUti.id_utilisateur
                                    //mRempliUti(dataTemplate, $TdAction)
                                })
                            })
                        }
                    }).dxCtrlTooltip("instance")
                    tt2.show()
                })
            }
        }
    }

    function mRempliIcone1(classIcone) {
        var $DivIcone = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo(container)
        $("<i class='" + classIcone + "' style='font-size:100%; line-height: 1;width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;'></i>").appendTo($DivIcone)
    }

    function mRempliIcone2(classIcone) {
        var $Div2 = $("<div style='position:absolute;bottom:0px;right:0px;height:60%;width:60%;border-top-left-radius:25%;z-index:1;overflow:hidden;'/>").appendTo(container)
        var $DivIcone = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo($Div2)
        $("<i class='" + classIcone + " dx-theme-accent-as-text-color' style='font-size:100%; line-height: 1;width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;'></i>").appendTo($DivIcone)
    }

    function mRempliImage1(imageUrl, classIcone, idTable, id) {
        if (lstUrlImageObjet.filter(function (o) { return o.url == imageUrl }).length > 0) {
            var data = lstUrlImageObjet.filter(function (o) { return o.url == imageUrl })[0]
            if (data.ok) {
                var $Div = $("<div style='width:100%;height:100%;overflow:hidden;background-image: url(" + data.urlLoad + ");background-size: cover;background-position: center;background-repeat: no-repeat;'/>").appendTo(container)
            } else {
                var $DivIcone = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo(container)
                $("<i class='" + classIcone + "' style='font-size:100%; line-height: 1;width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;'></i>").appendTo($DivIcone)
                url1 = ""
            }
        } else {
            // Essaye de charger l’image
            var $DivIcone = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo(container)
            $("<i class='" + classIcone + "' style='font-size:100%; line-height: 1;width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;'></i>").appendTo($DivIcone)
            $.ajax({
                url: imageUrl + "?d=" + mGet5sTimeKey(),
                type: 'HEAD',
                global: false,
                success: function () {
                    // Image existe, on l'affiche dans la balise img
                    $DivIcone.remove()
                    var url = imageUrl + "?d=" + mGet5sTimeKey()
                    var $Div = $("<div style='width:100%;height:100%;overflow:hidden;background-image: url(" + url + ");background-size: cover;background-position: center;background-repeat: no-repeat;'/>").appendTo(container)
                    if (lstUrlImageObjet.filter(function (o) { return o.url == imageUrl }).length == 0) {
                        lstUrlImageObjet.push({
                            url: imageUrl,
                            urlLoad: imageUrl + "?d=" + (new Date()).getTime(),
                            dcr: new Date(),
                            ok: true,
                            idTable: idTable,
                            id: id
                        })
                    }
                    //const img = $("<img style='width:100%;height:100%;object-fit:cover;position:absolute;'/>").appendTo($Div)
                    //img.attr('src', imageUrl + "?d=" + mGet5sTimeKey()).show();
                },
                error: function () {
                    // Image n'existe pas, on affiche l'icone
                    if (lstUrlImageObjet.filter(function (o) { return o.url == imageUrl }).length == 0) {
                        lstUrlImageObjet.push({
                            url: imageUrl,
                            urlLoad: imageUrl + "?d=" + (new Date()).getTime(),
                            dcr: new Date(),
                            ok: false,
                            idTable: idTable,
                            id: id
                        })
                    }
                    url1 = ""
                }
            });

        }
    }

    function mRempliImage2(imageUrl, classIcone, idTable, id) {
        var $Div2 = $("<div style='position:absolute;bottom:0px;right:0px;height:60%;width:60%;border-top-left-radius:25%;z-index:1;overflow:hidden;'/>").appendTo(container)
        if (lstUrlImageObjet.filter(function (o) { return o.url == imageUrl }).length > 0) {
            var data = lstUrlImageObjet.filter(function (o) { return o.url == imageUrl })[0]
            if (data.ok) {
                $Div2.css("box-shadow", "0 0 10px 2.5px #000000")
                var $Div = $("<div style='width:100%;height:100%;overflow:hidden;position:relative;background-image: url(" + data.urlLoad + ");background-size: cover;background-position: center;background-repeat: no-repeat;'/>").appendTo($Div2)
            } else {
                var $DivIcone = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo($Div2)
                $("<i class='" + classIcone + " dx-theme-accent-as-text-color' style='font-size:100%; line-height: 1;width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;'></i>").appendTo($DivIcone)
                url2 = ""
            }
        } else {
            var $DivIcone = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo($Div2)
            $("<i class='" + classIcone + " dx-theme-accent-as-text-color' style='font-size:100%; line-height: 1;width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;'></i>").appendTo($DivIcone)
            // Essaye de charger l’image
            $.ajax({
                url: imageUrl + "?d=" + mGet5sTimeKey(),
                type: 'HEAD',
                global: false,
                success: function () {
                    // Image existe, on l'affiche dans la balise img
                    $DivIcone.remove()
                    $Div2.css("box-shadow", "0 0 10px 2.5px #000000")
                    var url = imageUrl + "?d=" + mGet5sTimeKey()
                    var $Div = $("<div style='width:100%;height:100%;overflow:hidden;position:relative;background-image: url(" + url + ");background-size: cover;background-position: center;background-repeat: no-repeat;'/>").appendTo($Div2)
                    if (lstUrlImageObjet.filter(function (o) { return o.url == imageUrl }).length == 0) {
                        lstUrlImageObjet.push({
                            url: imageUrl,
                            urlLoad: imageUrl + "?d=" + (new Date()).getTime(),
                            dcr: new Date(),
                            ok: true,
                            idTable: idTable,
                            id: id
                        })
                    }
                    //const img = $("<img style='width:100%;height:100%;object-fit:cover;position:absolute;'/>").appendTo($Div)
                    //img.attr('src', imageUrl + "?d=" + mGet5sTimeKey()).show();
                },
                error: function () {
                    // Image n'existe pas, on affiche l'icone
                    if (lstUrlImageObjet.filter(function (o) { return o.url == imageUrl }).length == 0) {
                        lstUrlImageObjet.push({
                            url: imageUrl,
                            urlLoad: imageUrl + "?d=" + (new Date()).getTime(),
                            dcr: new Date(),
                            ok: false,
                            idTable: idTable,
                            id: id
                        })
                    }
                    url2 = ""
                }
            });
        }
    }

    this.mReload = function () { mConstruit() }

    function mCrop(urlImg) {
        var pathNameImageToSave = ""
        var idTableRef = option.idTable
        var idRef = option.id
        if (option.bddCtrl.table.mGetItem(option.idTable).nom == "structures_contact") {
            var dataContact = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.idTable).nom, option.id).objetMetier.mGetDataContact()
            pathNameImageToSave = option.bddCtrl.repertoireImageTable.substring(1) + "/" + option.bddCtrl.table.mGetItem(option.idTable).nom + "/" + dataContact.id_contact + ".png"
            idTableRef = option.bddCtrl.table.mGetItemFromNom("contact").id_table
            idRef = dataContact.id_contact
        } else {
            pathNameImageToSave = option.bddCtrl.repertoireImageTable.substring(1) + "/" + option.bddCtrl.table.mGetItem(option.idTable).nom + "/" + option.id + ".png"
        }

        var opt = {
            url: urlImg,
            formatImage: "png",
            enableOrientation: true,
            onAnnulation: function (e) { e.component.hide(); },
            onValidation: function (e) {
                //on a sauvegardé l'image en png
                mSaveImage()
                function mSaveImage() {
                    popCrop.hide();
                    option.bddCtrl.mAjaxCall({
                        command: "saveimgdata",
                        id_table: idTableRef,
                        id: idRef,
                        dataimg: e.component.dataImage
                    }, function (data) {
                        if (lstUrlImageObjet.filter(function (o) { return o.url == pathNameImageToSave }).length > 0) {
                            lstUrlImageObjet.splice(lstUrlImageObjet.indexOf(lstUrlImageObjet.filter(function (o) { return o.url == pathNameImageToSave })[0]), 1)
                        }
                        mRemoveSaveMemoryImage(idTableRef, idRef)
                        srcImg1 = pathNameImageToSave
                        mTriggerUpdateMemoryImage(option.bddCtrl, idTableRef, idRef)
                        mConstruit()
                    }, function () {
                    }, function () {
                    });
                }
            }
        }
        //if (srcImg1 != "") {
        opt.onSuppression = function (funcOk, funcAlways, funcKo) {
            srcImg1 = ""
            option.bddCtrl.mAjaxCall({
                command: "delimgdata",
                id_table: idTableRef,
                id: idRef
            }, function (data) {
                if (lstUrlImageObjet.filter(function (o) { return o.url == pathNameImageToSave }).length > 0) {
                    lstUrlImageObjet.splice(lstUrlImageObjet.indexOf(lstUrlImageObjet.filter(function (o) { return o.url == pathNameImageToSave })[0]), 1)
                }
                mRemoveSaveMemoryImage(idTableRef, idRef)
                mTriggerUpdateMemoryImage(option.bddCtrl, idTableRef, idRef)
                mConstruit()
            }, function () {
            }, function () {
            });
            popCrop.hide();
        }
        //}
        var popCrop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupCrop(opt).dxCtrlPopupCrop("instance")
        popCrop.show();

    }


    this.element = function () { return container }

    mConstruit();
}